import Register, {
  AccountCreationLocationState as LocationState,
} from "./Register";

export default Register;
export type AccountCreationLocationState = LocationState;
